import { TweenMax, TimelineMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
import EFAddPower from '@/components/UI/svg/LandingPage/EFAddPower';

const { EFPic } = createEFPic('/img/landingPage/');
const LINK_MAP: any = {
    us: [
        'https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40548220174409',
        'https://us.ecoflow.com/products/delta-pro-double-voltage-hub?variant=40521719251017',
        'https://us.ecoflow.com/products/transfer-switch?variant=40516904222793',
    ],
    za: ['https://za.ecoflow.com/pages/portable-power-stations', ''],
    au: [`https://au.ecoflow.com/collections/portable-power-stations`, 'https://au.ecoflow.com/products/transfer-switch'],
    ca: ['/ca/smart-home-panel', '/ca/smart-home-panel-2'],
};

let sceneEnterB: any = null,
    sceneLeaveB: any = null;
export default function OthersSaying({}: any) {
    const { useLang, useRouter, useEffect, Link, useState, useRef, gtm } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const [visible, setVisible] = useState(false);
    const [active, setActive] = useState(0);
    const video1Ref = useRef();
    const video2Ref = useRef();
    const [changeCount, setChangeCount] = useState(0);
    const SHOW_TS_BUNDLE_SITE = ['sa', 'za', 'au'].includes(locale);
    const IS_NA_SITES = ['us', 'ca'].includes(locale);

    // 自动切换两次后不再切换
    const handlePlayEnd = () => {
        if (active === 0) {
            if (changeCount < 2) {
                setActive(1);
                setChangeCount(changeCount + 1);
                video2Ref.current.play();
            } else {
                video1Ref.current.play();
            }
        }
        if (active === 1) {
            if (changeCount < 2) {
                setActive(0);
                setChangeCount(changeCount + 1);
                video1Ref.current.play();
            } else {
                video2Ref.current.play();
            }
        }
    };

    const handleChangTab = (n: number) => {
        changeCount < 2 && setChangeCount(2);
        if (active === n) return;
        if (n === 0) {
            setActive(0);
            video1Ref.current.currentTime = 0;
            video1Ref.current.play();
        }
        if (n === 1) {
            setActive(1);
            video2Ref.current.currentTime = 0;
            video2Ref.current.play();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneEnterB) {
                    AniContainer.removeScene(sceneEnterB);
                    sceneEnterB = null;
                }
                if (sceneLeaveB) {
                    AniContainer.removeScene(sceneLeaveB);
                    sceneLeaveB = null;
                }
                const videos = document.querySelector('.whole-home-C .videos') as HTMLUListElement;
                if (videos) {
                    sceneEnterB = AniContainer.create({
                        triggerElement: '.whole-home-C .videos .video.active',
                        triggerHook: 1,
                        offset: videos?.offsetHeight / 2,
                        duration: window?.innerHeight - videos?.offsetHeight / 2,
                        onEnter: () => {
                            if (active === 0) {
                                video1Ref.current.play();
                            }
                            if (active === 1) {
                                video2Ref.current.play();
                            }
                        },
                    });

                    sceneLeaveB = AniContainer.create({
                        triggerElement: '.whole-home-C .videos .video.active',
                        triggerHook: 1,
                        offset: 0,
                        duration: window?.innerHeight + videos?.offsetHeight,
                        onLeave: () => {
                            if (active === 0) {
                                video1Ref.current.pause();
                                video1Ref.current.currentTime = 0;
                            }
                            if (active === 1) {
                                video2Ref.current.pause();
                                video2Ref.current.currentTime = 0;
                            }
                        },
                    });
                }
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneEnterB) {
                    AniContainer.removeScene(sceneEnterB);
                    sceneEnterB = null;
                }
                if (sceneLeaveB) {
                    AniContainer.removeScene(sceneLeaveB);
                    sceneLeaveB = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    useEffect(() => {
        if (!IS_NA_SITES) {
            const controller = new ScrollMagic.Controller();

            const sceneA1 = new ScrollMagic.Scene({
                triggerElement: '.othersSaying .cards',
                offset: 0, //从开始点滚动多少px触发,可为负数
                triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '90%', //和滚动条绑定到一起,场景持续滚动距离为 800px
            });

            const sceneA2 = new ScrollMagic.Scene({
                triggerElement: '.othersSaying .title',
                offset: '100px', //从开始点滚动多少px触发,可为负数
                triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '10%', //和滚动条绑定到一起,场景持续滚动距离为 800px
            });

            const sceneA3 = new ScrollMagic.Scene({
                triggerElement: '.othersSaying .text',
                offset: '120px', //从开始点滚动多少px触发,可为负数
                triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '40%', //和滚动条绑定到一起,场景持续滚动距离为 800px
            });

            const tweenA1 = TweenMax.to('.othersSaying .cards-top', 1, {
                right: 0,
                left: 'unset',
                ease: 'linear',
            });

            const tweenA2 = TweenMax.to('.othersSaying .cards-bottom', 1, {
                right: 'unset',
                left: 0,
                ease: 'linear',
            });

            const tweenA3 = TweenMax.fromTo(
                '.othersSaying .title',
                1,
                { opacity: 0 },
                {
                    opacity: 1,
                    ease: 'linear',
                },
            );
            const tweenA4 = TweenMax.fromTo(
                '.othersSaying .text',
                1,
                { y: 50, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    ease: 'linear',
                },
            );
            const timelineA1 = new TimelineMax();
            timelineA1.add(tweenA1).add(tweenA2, 0);
            sceneA1.setTween(timelineA1);

            sceneA2.setTween(tweenA3);
            sceneA3.setTween(tweenA4);

            controller.addScene(sceneA1);
            controller.addScene(sceneA2);
            controller.addScene(sceneA3);
        }
    }, []);

    const scrollToTS = () => {
        // window.scrollTo({
        //     top: 1000,
        //     behavior: 'smooth',
        // });
    };

    return (
        <div className={`${css.othersSaying} othersSaying`}>
            <div className="text">
                {t.rich('secC_Content', {
                    link1: (text: string) => (
                        <Link className="high-light" href={LINK_MAP[locale][0] || ''}>
                            {text}{' '}
                        </Link>
                    ),
                    link2: (text: string) =>
                        ['za'].includes(locale) ? (
                            <span className="high-light" style={{ textDecoration: 'unset' }} onClick={scrollToTS}>
                                {text}{' '}
                            </span>
                        ) : (
                            <Link className="high-light" href={LINK_MAP[locale][1] || ''}>
                                {text}{' '}
                            </Link>
                        ),
                    link3: (text: string) => (
                        <Link className="high-light" href={LINK_MAP[locale][2] || ''}>
                            {text}{' '}
                        </Link>
                    ),
                })}
            </div>
            {!IS_NA_SITES && (
                <div className={`power-inlet-box ${visible ? 'isShow' : ''}`}>
                    {SHOW_TS_BUNDLE_SITE && (
                        <EFVideo sources={['/video/landingPage/h5/power_inlet_box2.mp4', '/video/landingPage/h5/power_inlet_box2.mp4']} autoPlay />
                    )}
                    {!SHOW_TS_BUNDLE_SITE && (
                        <EFVideo sources={['/video/landingPage/h5/power_inlet_box.webm', '/video/landingPage/h5/power_inlet_box.mp4']} autoPlay />
                    )}
                    <div className="popover">
                        <div className="btn" onClick={() => setVisible(!visible)}>
                            <div className="text">{t('secC_product_1')}</div>
                            <div className="icon">
                                <EFAddPower />
                            </div>
                        </div>
                        <div className="modal">
                            {SHOW_TS_BUNDLE_SITE && (
                                <div className="content">
                                    <div className="writing">
                                        <div className="name">{t('c_transfer_switch')}</div>
                                        <p>
                                            {t.rich('c_transfer_switch_desc', {
                                                link: (text: string) => (
                                                    <Link className="desc-link" href={LINK_MAP[locale][0] || ''}>
                                                        {text}
                                                    </Link>
                                                ),
                                            })}
                                        </p>
                                    </div>
                                    <div className="img2">
                                        {/* // https://ecoflow.feishu.cn/docx/YLRadFfARoRxJwx7ADIcKtgXnPh */}
                                        <EFPic
                                            name={
                                                locale === 'za'
                                                    ? ['transfer_switch_za.webp', 'transfer_switch_za.png']
                                                    : ['transfer_switch.webp', 'transfer_switch.png']
                                            }
                                            alt={'transfer'}
                                        />
                                    </div>
                                </div>
                            )}
                            {!SHOW_TS_BUNDLE_SITE && (
                                <div className="content">
                                    <div className="writing">
                                        <div className="name">{t('secC_product_1')}</div>
                                        <p>{t('secC_product_desc_1')}</p>
                                    </div>
                                    <div className="img1">
                                        <EFPic name={['h5/power_inlet_box/transfer.webp', 'h5/power_inlet_box/transfer.jpg']} alt={'transfer'} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {IS_NA_SITES && (
                <>
                    <ul className="videos">
                        <li className={`video ${active === 0 ? 'active' : ''}`}>
                            <video
                                ref={video1Ref}
                                src={`/responsive/video/delta-pro-ultra/launch/2_1.mp4`}
                                muted
                                playsInline
                                preload="auto"
                                width="100%"
                                height="100%"
                                poster="/responsive/picture/delta-pro-ultra/launch/2_1.jpg"
                                aria-label={t('secB_tab1')}
                                onEnded={handlePlayEnd}
                            />

                            <div className="float-msg">
                                <svg className="light-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="21" viewBox="0 0 11 21" fill="none">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6.93401 13.8007L10.2631 19.5668L10.8833 19.2087L0.62021 1.43259L0 1.79067L2.7367 6.53077L0.000196251 10.6528H3.76002L2.86483 20.5L6.93401 13.8007ZM7.73947 12.4747L3.57698 5.26502L7.07225 0L6.71417 8.41485H10.2054L7.73947 12.4747Z"
                                        fill="white"
                                    />
                                </svg>
                                <p className="icon-text">{t('secB_icon')}</p>
                            </div>
                        </li>
                        <li className={`video ${active === 1 ? 'active' : ''}`}>
                            <video
                                ref={video2Ref}
                                src={'/responsive/video/delta-pro-ultra/launch/2_2.mp4'}
                                muted
                                playsInline
                                preload="auto"
                                width="100%"
                                height="100%"
                                poster="/responsive/picture/delta-pro-ultra/launch/2_2.jpg"
                                aria-label={t('secB_tab2')}
                                onEnded={handlePlayEnd}
                            />
                        </li>
                    </ul>
                    <ul className="tabs">
                        <li className={`tab ${active === 0 ? 'active' : ''}`} onClick={() => handleChangTab(0)}>
                            {t('secB_tab1')}
                        </li>

                        <li className={`tab ${active === 1 ? 'active' : ''}`} onClick={() => handleChangTab(1)}>
                            {t('secB_tab2')}
                        </li>
                    </ul>
                </>
            )}
        </div>
    );
}
